import * as React from "react";
const SvgPlus24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "black",
        viewBox: "0 0 14 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8 6V0H6v6H0v2h6v6h2V8h6V6H8Z",
      clipRule: "evenodd"
    })
  );
export default SvgPlus24Px;
